import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';

// 3rd party imports
import notify from 'devextreme/ui/notify';
import { DxPopupComponent } from 'devextreme-angular';

// Service imports
import { VendorSharedService } from '../../_services/vendor-shared.service';
import { ServerErrorService } from '../../../_services/shared-services/server-error.service';

// Models import
import { WFVendorNotesResultDto } from '../../_models/wf-vendor-notes-result-dto';
import { WFVendorNotesParameterDto } from '../../_models/wf-vendor-notes-parameter-dto';
import { SaveCommunityVendorNotesParametersDto } from '../../_models/save-community-vendor-notes-parameters-dto';

// constant imports
import { MessageInterval } from '../../../_constants/messages-intervals';

@Component({
    selector: 'app-workflow-vendor-notes',
    templateUrl: './workflow-vendor-notes.component.html',
    styleUrls: ['./workflow-vendor-notes.component.scss']
})
export class WorkflowVendorNotesComponent implements OnInit {
    @ViewChild('notesPopup', { static: false }) notesPopup: DxPopupComponent;

    @Input() communityId: number;
    @Input() vendorCode: string;
    @Input() communityVendorId: number;
    @Input() hasNotes = false;
    @Input() vendorName: string;

    @Output() onVendorNotesClose = new EventEmitter<any>();

    previousVendorNotes: string;
    isNotesSaved = false;
    visible = false;

    constructor(
        private readonly vendorSharedService: VendorSharedService,
        private readonly errorService: ServerErrorService
    ) {}

    ngOnInit() {
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onNotesPopupShown(): void {
        this.notesPopup.instance.repaint();
        this.getWorkflowVendorPreviousNotes();
    }

    onNotesPopClose(): void {
        this.closeNotes();
    }

    onSaveNotes(newNote: string): void {
        this.saveWorkflowVendorNotes(newNote);
    }

    private getWorkflowVendorPreviousNotes(clearCache = false): void {
        const baseParams: WFVendorNotesParameterDto = new WFVendorNotesParameterDto();
        baseParams.communityId = this.communityId;
        baseParams.vendorCode = this.vendorCode;
        baseParams.clearCache = clearCache || this.hasNotes;

        this.vendorSharedService.getVendorNotes(baseParams).subscribe(
            (result: WFVendorNotesResultDto) => {
                this.previousVendorNotes = result.note;
                if (clearCache) {
                    this.isNotesSaved = true;
                }
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private saveWorkflowVendorNotes(notes: string): void {
        const baseParams: SaveCommunityVendorNotesParametersDto = new SaveCommunityVendorNotesParametersDto();
        baseParams.communityId = this.communityId;
        baseParams.vendorCode = this.vendorCode;
        baseParams.newNote = notes;

        this.vendorSharedService.saveVendorNotes(baseParams).subscribe(
            (result: any) => {
                notify('Notes successfully saved.', 'Success', MessageInterval.successMsgInterval);
                this.getWorkflowVendorPreviousNotes(true);
                this.closeNotes();
            },
            (error) => {
                this.errorService.displayError(error);
            }
        );
    }

    private closeNotes(): void {
        this.visible = false;
        this.onVendorNotesClose.emit(this.isNotesSaved);
    }
}
